<template>
<form class="image-uploader"
	:class="{ dragover: dragover }"
	@submit.prevent="onSubmit" @dragover.prevent
	@drop="onDrop($event); dragover = false"
	@dragenter="dragover = true"
	@dragleave.prevent="dragover = false"
>
	<div ref="dropZone">
		<p>Drag &amp; Drop Image, or:</p>
		<input type="file" @change="onBrowse">
	</div>
	<picture v-if="fileType === false"> <!-- Old preview -->
		<img
			ref="img"
			:src="imgUrl"
			style="max-width:240px"
		>
	</picture>
	<video
		v-if="fileType === 'video'"
		:key="filename"
		ref="video"
		loop
		autoplay
		muted
		style="width: 240px; height: 120px; overflow: hidden; display: block;" @loadedmetadata="onLoad"
	> <!-- video preview -->
		<source
			:src="dataUrl"
			:type="mimeType"
		>
	</video>
	<picture
		v-if="fileType === 'image'"
		:key="filename"
		style="width: 240px; height: 120px; overflow: hidden;  display: block;"
	> <!-- image preview -->
		<img
			ref="img"
			:src="dataUrl"
			:type="mimeType"
			@load="onLoad"
		>
	</picture>
	<input v-show="dataUrl && encodeProgress == 0" type="submit" class="button" value="Confirm image change">
	<p v-show="encodeProgress > 0">
		Encoding: {{ encodeProgress }}%
	</p>
	<p>Max frames<a title="Animated images will be truncated to a maximum of 120 frames" class="help">?</a>: 120</p>
	<p>Max size<a title="For animated images and video, you can use a site like ezgif.com to crop video files" class="help">?</a>: 360x180px</p>
	<div v-if="oldUrl">
		Your image before the new image uploads change, for reference:<br>
		<img
			:src="oldUrl"
			style="width:64px; height:48px;"
		>
	</div>
</form>
</template>

<script>
import socket from '../js/socket.js'
import userFns from '../js/user-functions.js'

const validTypes = [
		'image/png',
		'image/jpg',
		'image/jpeg',
		'image/gif',
		'image/bmp',
		'image/webp',
		'video/mp4',
		'video/mpeg',
		'video/webm',
		'video/ogg',
		'video/quicktime',
		'video/3gpp',
		'video/x-m4v',
		'video/x-ms-wmv',
		'video/x-msvideo'
	],
	reader = new FileReader()

export default {
	props: {
		user: {
			type: [Object],
			required: true
		}
	},
	data: () => ({
		file: false,
		dataUrl: false,
		fileType: false,
		dragover: false,
		encodeProgress: 0
	}),
	computed: {
		imgUrl: function(){
			return userFns.imgUrl( this.user )
		},
		oldUrl: function(){
			if( this.user && this.user.props.iconExt && this.user.props.animateIcon === null ){
				return '//img.rphaven.com/th_' + this.user.props.id + '.' + this.user.props.iconExt
			}
			return false
		}
	},
	watch: {
		file: function( value ){
			if( value ){
				reader.readAsDataURL( this.file )
				reader.onload = ( readFile ) => {
					this.dataUrl = readFile.target.result

					const mimeType = this.file.type

					if( validTypes.includes( mimeType ) ){
						const fileType = mimeType.slice( 0, mimeType.indexOf( '/' ) ) // 'image' or 'video'

						this.filename = this.file.name
						this.mimeType = mimeType
						this.fileType = fileType
						//see if this works and doens't break vue. Would be cleaner
						//Object.assign( this, {mimeType, fileType})
					} else {
						this.dataUrl = false
					}
				}
			} else {
				this.dataUrl = false
			}
		}
	},
	created: function(){
		socket.on( 'encode-progress', ( float ) => {
			console.log( 'encode-progress', float )
			this.encodeProgress = ( float * 100 ).toFixed( 0 )
			if( this.encodeProgress === 100 ){
				this.encodeProgress = 'complete'
			}
		})

		socket.on( 'upload-complete', () => {
			this.encodeProgress = 0
		})
	},
	methods: {
		onSubmit: function( ev ){
			console.log( 'submit', this.file, this.dataUrl )
			socket.emit( 'upload', {
				userid: this.user.props.id,
				base64: this.dataUrl
			})
		},
		onLoad: function( ev ){
			this.popper.update()

			const width = ev.target.width || ev.target.videoWidth,
				height = ev.target.height || ev.target.videoHeight

			// console.log('width and height', width, height, 'wider', this.file, ev.target, this.sourceStyle)
		},
		onBrowse: function( ev ){
			this.file = ev.target.files[0]
		},
		onDrop: function( ev ){
			ev.preventDefault()
			ev.stopPropagation()
			this.file = ev.dataTransfer.files[0]
		}
	}
}

</script>
<style>
	.image-uploader {
		background:white;
		padding:0.25rem;
		border:0.25rem solid transparent;
	}
	.dragover {
		border:0.25rem dashed grey;
	}
	.dragover:after {
		content:'Drop file to preview upload';
		position: absolute;
		bottom: 0; left: 0; right: 0;
		background: rgba(140, 150, 200, 0.7);
		background: radial-gradient(circle, rgba(140, 150, 200, 0.7) 50%, white 100%);
		display:flex;
		align-content: center;
		flex-direction: column;
		justify-content: center;
		padding:5%;
		font-weight:600;
		font-size:1.2rem;
		line-height:auto;
		border-radius:3px;
		cursor:default;
		height: 2rem;
	}

	.image-uploader img, .image-uploader source {
		object-fit: cover;
		width:100%;
		height:100%;
	}

	.image-uploader input {
		width:240px;
	}
</style>